class NewsController {
  constructor() {
    this.name = 'news';
  }
}

export default NewsController;



// WEBPACK FOOTER //
// ./client/app/components/news/news.controller.js